export const catalogRouteEntries = {
  platformsList: () => import('./presentation/PlatformsListPage'),
  platformForm: () => import('./presentation/PlatformFormPage'),
  operatingSystemsList: () => import('./presentation/OperatingSystemsListPage'),
  operatingSystemForm: () => import('./presentation/OperatingSystemFormPage'),
  databaseSystemsList: () => import('./presentation/DatabaseSystemsListPage'),
  databaseSystemForm: () => import('./presentation/DatabaseSystemFormPage'),
  sapProductsList: () => import('./presentation/SapProductsListPage'),
  sapProductForm: () => import('./presentation/SapProductFormPage'),
  subsystemsList: () => import('./presentation/SubsystemsListPage'),
  subsystemForm: () => import('./presentation/SubsystemFormPage'),
} as const;